<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<div class="container-fluid h-100">
  <br><br><br><br><br><br>
  <div class="row h-100">
    <div class="col section-content">
      <div class="content-container">
        <div class="icon-circle">
          <i class="bi bi-box-arrow-in-left">
          </i>
        </div>
        <app-st-header-title [inputVal]="'Consultant Referral Code Successful'"></app-st-header-title>
        <br>
        <br>
        <app-st-span [inputVal]="'Thank you for successfully verifying your referral code. Your account is already in our system. Please sign in.'"></app-st-span>
        <br>
        <br>
        <app-st-span [inputVal]="'Click here if you are not directed.'"></app-st-span>
        <br>
        <br>
        <app-st-button [label]="'Login'" [primary]="true" (onClick)="onGoToLogin()"></app-st-button>
      </div>
    </div>
  </div>
</div>
